import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IncludedInModule } from '@portal-core/general/pipes/included-in/included-in.module';
import { WorkspaceFileUserStatusAvatarIndicatorComponent } from './workspace-file-user-status-avatar-indicator.component';

@NgModule({
  declarations: [WorkspaceFileUserStatusAvatarIndicatorComponent],
  imports: [
    CommonModule,
    IncludedInModule,
    MatIconModule
  ],
  exports: [
    WorkspaceFileUserStatusAvatarIndicatorComponent
  ]
})
export class WorkspaceFileUserStatusAvatarIndicatorModule { }
